import React, { useContext } from 'react';
import validators from '../../../components/forms/validation/validators';

// Context
import { CreateAWidgetFormContext } from './context/create-a-widget-form-context';

// Components
import Form from '../../../components/forms/form';
import FormFieldDimension from './form-fields/form-field-dimension';

const CreateAWidgetFormLineGraph = () => {
    // Context
    const { currentAvailableMetrics } = useContext(CreateAWidgetFormContext);

    return (
        <>
            <Form.Section>
                <Form.SectionTitle>Display Settings</Form.SectionTitle>
                <FormFieldDimension label="Dimension" />
                <Form.Field>
                    <Form.InputLabel htmlFor="graphMetric" label="Metric / Y Axis" />
                    <Form.InputSelect
                        name="graphMetric"
                        options={currentAvailableMetrics}
                        placeholder="Please select a metric"
                        validators={[validators.required]}
                    />
                </Form.Field>
            </Form.Section>
            <Form.Section>
                <Form.SectionTitle>Additional Settings</Form.SectionTitle>

                <Form.Field>
                    <Form.InputCheckbox name="interpolated" label="Interpolate data?" />
                </Form.Field>

                <Form.Field>
                    <Form.InputCheckbox name="showFillColor" label="Show fill colour?" />
                </Form.Field>
            </Form.Section>
        </>
    );
};

export default CreateAWidgetFormLineGraph;
